/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.98"
        height="18.98"
        viewBox="0 0 18.98 18.98"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M9.49 0a9.49 9.49 0 1 0 9.49 9.49A9.49 9.49 0 0 0 9.49 0Zm0 18a8.49 8.49 0 1 1 8.49-8.49 8.49 8.49 0 0 1-8.49 8.47ZM4.19 6.5h10.55v1H4.19Zm1.68 3h7.19v1H5.89Zm1.69 2.92h3.82v1H7.56Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CircleWithThreeMultiLengthLinesIcon';

export default Icon;
